import { gql, useMutation } from '@apollo/client';
import {
  CreateAuthorMutation,
  CreateAuthorMutationVariables,
  UpdateAuthorMutation,
  UpdateAuthorMutationVariables,
} from '../../__generated__/queries-web';

const UPDATE_AUTHOR = gql`
  mutation UpdateAuthor(
    $where: AuthorUniqueFilterInput!
    $data: AuthorUpdateInput!
  ) {
    updateAuthor(where: $where, data: $data) {
      avatarUrl
      brandKey
      description
      facebookId
      googleId
      id
      instagramId
      isMain
      linkedinId
      media
      name
      pinterestId
      snapchatId
      twitterId
      userId
      resume
      email
      media
      hasPublicProfile
      isExternal
      histories(first: 1000) {
        createdAt
        id
        user {
          ... on OneUser {
            id
            name
            avatarUrl
          }
        }
      }
      attributes(first: 100) {
        attribute {
          id
          title
        }
      }
    }
  }
`;

export const useAuthorUpdater = () =>
  useMutation<UpdateAuthorMutation, UpdateAuthorMutationVariables>(
    UPDATE_AUTHOR,
  );

const CREATE_AUTHOR = gql`
  mutation CreateAuthor($data: AuthorCreationInput!) {
    createAuthor(data: $data) {
      avatarUrl
      brandKey
      description
      facebookId
      googleId
      id
      instagramId
      isMain
      linkedinId
      media
      name
      pinterestId
      snapchatId
      twitterId
      userId
      resume
      email
      media
      hasPublicProfile
      isExternal
      histories(first: 1000) {
        createdAt
        id
        user {
          ... on OneUser {
            id
            name
            avatarUrl
          }
        }
      }
      attributes(first: 100) {
        attribute {
          id
          title
        }
      }
    }
  }
`;

export const useAuthorCreate = () =>
  useMutation<CreateAuthorMutation, CreateAuthorMutationVariables>(
    CREATE_AUTHOR,
  );
